import is from 'is_js';
import { SET_SERVER_ERROR, RESET_SERVER_ERROR } from './api';
import { createSlice } from '@reduxjs/toolkit';

const apiSlice = createSlice({
  name: 'core',
  initialState: {
    serverError: false,
    isIOS: is.ios(),
    disablePreventClose: false,
    tealiumScriptLoaded: false,
  },
  reducers: {
    setDisablePreventClose(state, action) {
      state.disablePreventClose = action.payload;
    },
    setTealiumScriptLoaded(state, action) {
      state.tealiumScriptLoaded = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(SET_SERVER_ERROR, (state, _) => {
        state.serverError = true;
      })
      .addCase(RESET_SERVER_ERROR, (state, _) => {
        state.serverError = false;
      });
  },
  selectors: {
    getServerError: state => state.serverError,
    getIsIOS: state => state.isIOS,
    getDisablePreventClose: state => state.disablePreventClose,
    getTealiumScriptLoaded: state => state.tealiumScriptLoaded,
  },
});
const reducer = apiSlice.reducer;
export const {
  setDisablePreventClose,
  setTealiumScriptLoaded,
} = apiSlice.actions;
export const {
  getServerError,
  getIsIOS,
  getDisablePreventClose,
  getTealiumScriptLoaded,
} = apiSlice.selectors;

export default reducer;
